var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import Tag from '../Tag/Tag';
import Input from '../Input';
import styles from './InputWithTags.scss';
import omit from 'omit';
import classNames from 'classnames';

var InputWithTags = function (_React$Component) {
  _inherits(InputWithTags, _React$Component);

  function InputWithTags(props) {
    _classCallCheck(this, InputWithTags);

    var _this = _possibleConstructorReturn(this, (InputWithTags.__proto__ || Object.getPrototypeOf(InputWithTags)).call(this, props));

    _this.focus = _this.focus.bind(_this);
    _this.blur = _this.blur.bind(_this);
    _this.select = _this.select.bind(_this);

    _this.state = { inputValue: '', inputHasFocus: false };
    return _this;
  }

  _createClass(InputWithTags, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.autoFocus && this.props.onFocus();
    }
  }, {
    key: 'handleInputFocus',
    value: function handleInputFocus() {
      this.input.focus();
      this.setState({ inputHasFocus: true });
    }
  }, {
    key: 'handleInputBlur',
    value: function handleInputBlur() {
      this.setState({ inputHasFocus: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames,
          _this2 = this;

      var _props = this.props,
          tags = _props.tags,
          onRemoveTag = _props.onRemoveTag,
          placeholder = _props.placeholder,
          error = _props.error,
          disabled = _props.disabled,
          delimiters = _props.delimiters,
          inputProps = _objectWithoutProperties(_props, ['tags', 'onRemoveTag', 'placeholder', 'error', 'disabled', 'delimiters']);

      var hasFocus = this.state.inputHasFocus;

      var className = classNames((_classNames = {}, _defineProperty(_classNames, styles.tagsContainer, true), _defineProperty(_classNames, styles.disabled, disabled), _defineProperty(_classNames, styles.error, error), _defineProperty(_classNames, styles.hasFocus, hasFocus), _classNames));

      var desiredProps = omit(['onManuallyInput', 'inputElement', 'closeOnSelect', 'predicate', 'menuArrow', 'onClickOutside', 'fixedHeader', 'fixedFooter', 'dataHook'], inputProps);
      var fontSize = desiredProps.size && desiredProps.size === 'small' ? '14px' : '16px';

      return React.createElement(
        'div',
        { className: className, onClick: function onClick() {
            return _this2.handleInputFocus();
          } },
        tags.map(function (_ref) {
          var label = _ref.label,
              rest = _objectWithoutProperties(_ref, ['label']);

          return React.createElement(
            Tag,
            _extends({ key: rest.id, disabled: disabled, onRemove: onRemoveTag }, rest),
            label
          );
        }),
        React.createElement(
          'span',
          { className: styles.input, 'data-hook': 'inner-input-with-tags' },
          React.createElement(
            'div',
            { className: styles.hiddenDiv, style: { fontSize: fontSize } },
            this.state.inputValue
          ),
          React.createElement(Input, _extends({
            ref: function ref(input) {
              return _this2.input = input;
            },
            onBlur: function onBlur() {
              return _this2.handleInputBlur();
            },
            placeholder: tags.length === 0 ? placeholder : ''
          }, desiredProps, {
            disabled: disabled,
            onChange: function onChange(e) {
              if (!delimiters.includes(e.target.value)) {
                _this2.setState({ inputValue: e.target.value });
                desiredProps.onChange && desiredProps.onChange(e);
              }
            }
          }))
        )
      );
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: 'select',
    value: function select() {
      this.input.select();
    }
  }]);

  return InputWithTags;
}(React.Component);

InputWithTags.propTypes = {
  onRemoveTag: PropTypes.func,
  tags: PropTypes.array,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  onFocus: PropTypes.func,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  delimiters: PropTypes.array
};

InputWithTags.defaultProps = {
  onRemoveTag: function onRemoveTag() {},
  tags: [],
  placeholder: '',
  delimiters: []
};

export default InputWithTags;
//# sourceMappingURL=InputWithTags.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/MultiSelect/InputWithTags.js